import FaithEmbed from "./images/FaithEmbed";

const NotFound = {
        firstName: 'Page Not Found!',
        title: 'The Links above can take you back.',
        id: 'PNFlctybck',
        dates: '404',
        image: FaithEmbed,
        quotes: [
            {
                title: 'The Links above can take you back.',
                id: 'PNFlctybck05',
                date: '404',
                headTitle: `404 Page Note Found`,
                headDescription: `404 Page Not Found`,
                content: [
                    {normal: `We're not sure what happened but rest assured the links above can take you back into the site where you can continue to browse 
                    for additional material. We apologize for the inconvenience. If you are experiencing a problem with a bad link or some other error on the True 
                    Liberty North website, please contact us and let us know. Thanks for your help!`},
                    {normal: ``},
                    {normal: ``},
                    {normal: ``},
                    {normal: ``},
                    {normal: ``},
                    {bold: ``, normal: ``}
                ],
                considerations: [
                    {
                        name: '',
                        title: '',
                        date: '',
                        content: [``]
                    },
                    {
                        name: '',
                        title: '',
                        date: '',
                        content: [``]
                    },
                    {
                        name: '',
                        title: '',
                        date: '',
                        content: [``]
                    }
                ]
    }
]
    };

export default NotFound;